import {useEffect, useRef, useState} from "react";
import LogoTwygs from "../../assets/logo-twygs.svg";
import {getUserInfo} from "../../apis/twygs-detail";
import Cookies from "js-cookie";
import AvatarIcon from "../../assets/ava-icon.svg";
import AdvertiserIcon from "../../assets/advertiser-icon.svg";
import CreatorIcon from "../../assets/creator-icon.svg";
import SettingIcon from "../../assets/setting-icon.svg";
import LogOutIcon from "../../assets/logout-icon.svg";
import {useClickOutside} from "../../hooks/useOutsideClick";
import {useNavigate} from "react-router-dom";
import {removeAllCookies} from "../../constants";
import {useAtom} from "jotai";
import {profileAtom} from "../Settings/atom";

const HeaderComponent = () => {
  const [profile, setProfile] = useAtom(profileAtom);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const listItem = [
    {
      name: "Twygs Ads",
      icon: AdvertiserIcon,
      onClick: () => {
        window.open(`${process.env.REACT_APP_ADVERTISER_URL}`, "_blank");
      },
    },
    {
      name: "Creator Studio",
      icon: CreatorIcon,
      onClick: () => {
        window.open(`${process.env.REACT_APP_CREATOR_URL}`, "_blank");
      },
    },
    {
      name: "Settings",
      icon: SettingIcon,
      onClick: () => {
        navigate("/settings");
      },
    },
    {
      name: "Log Out",
      icon: LogOutIcon,
      onClick: () => {
        removeAllCookies();
        localStorage.removeItem("user");
        navigate("/explore");
      },
    },
  ];

  const token = Cookies.get("token");

  useClickOutside(dropdownRef, () => {
    setOpen(false);
  });

  const handleToggleProfileModal = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    const fetchUser = async () => {
      if (token) {
        const result = await getUserInfo();
        setProfile(result);
        localStorage.setItem("user", JSON.stringify(result));
      }
    };
    if (token) fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="flex flex-col fixed top-0 left-0 w-full z-10 font-nunito">
      <div className="bg-white w-full shadow-sm">
        <div className="m-auto max-w-[1660px] px-5 w-full py-2 md:py-4 flex items-center">
          <a href="/explore">
            <img src={LogoTwygs} alt="logo" className="h-8 md:h-10" />
          </a>
          {token && profile ? (
            <div className="ml-auto flex items-center gap-[15px] relative">
              <p className="text-[#084F4B] font-semibold text-lg">
                {profile?.username}
              </p>
              <img
                onClick={handleToggleProfileModal}
                src={profile?.imgUrl || AvatarIcon}
                alt="avatar"
                className="w-[40px] h-[40px] rounded-full border border-solid border-[#E6E7EB] cursor-pointer"
              />
              {open && (
                <div
                  ref={dropdownRef}
                  className="absolute z-20 top-[50px] right-0 p-[18px] flex flex-col gap-[8px] bg-white w-[270px] rounded-[12px] border border-solid border-[#F2F3F7] shadow-[0px_8px_12px_0px_#80808026]"
                >
                  {listItem.map((item, index) => (
                    <div
                      onClick={() => {
                        item.onClick();
                        setOpen(false);
                      }}
                      key={index}
                      className="hover:bg-[#A6D38D] hover:rounded-[8px] cursor-pointer flex items-center gap-[12px] px-[12px] py-[8px]"
                    >
                      <img src={item.icon} alt={item.icon} />
                      <p className="font-extrabold text-[#084F4B]">
                        {item.name}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div className="ml-auto flex items-center gap-2">
              <a
                href={`${process.env.REACT_APP_TWYGS_AUTH_URL}signup`}
                target="_self"
                id="btn"
                className="cursor-pointer flex items-center justify-center bg-white h-[32px] md:h-[40px] min-w-[100px] md:min-w-[120px] w-full custom-color border custom-border-dark-green !rounded-[40px] text-[13px] md:text-base font-black hover:opacity-80"
              >
                Get started
              </a>
              <a
                href={`${process.env.REACT_APP_TWYGS_AUTH_URL}login`}
                target="_self"
                id="btn"
                className="cursor-pointer bg-custom h-[32px] md:h-[40px] flex items-center justify-center min-w-[100px] md:min-w-[120px] w-full !rounded-[40px] !text-white text-[13px] md:text-base font-black hover:opacity-80"
              >
                Login
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderComponent;
